export default {
  name: 'fullparent',
  bind: function (el) {
    if (el.parentElement) {
      el.style.maxHeight = el.parentElement.clientHeight + 'px'
      el.style.height = el.parentElement.clientHeight + 'px'
      el.style.maxWidth = el.parentElement.clientWidth + 'px'
      el.style.width = el.parentElement.clientWidth + 'px'
    }
  },
  update: function (el) {
    if (el.parentElement) {
      el.style.maxHeight = el.parentElement.clientHeight + 'px'
      el.style.height = el.parentElement.clientHeight + 'px'
      el.style.maxWidth = el.parentElement.clientWidth + 'px'
      el.style.width = el.parentElement.clientWidth + 'px'
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/fullparent.js